export * from "./customer-dashboard.component";
